import { createMuiTheme } from "@material-ui/core";

const theme = createMuiTheme({
    palette: {
      type: 'light',
      background: {
        default: '#ffffff'
      }
    },
    typography: {
      fontSize: 12,
    }
});

export default theme;